import { useRef } from "react";
import Select, { ActionMeta } from "react-select";
import { getTrainerResults, setWornItem } from "./equipmentTrainerSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

export function WornSelect({ slot, options, ...rest }: any) {
  const dispatch = useAppDispatch();
  const name = useAppSelector(x => (x.equipmentTrainer.worn as any)[slot]);
  const value = options.find((x: any) => x.value === name) ?? null;
  const myRef = useRef<any>(null);
  const isMenuOpen = useRef<boolean>(false);

  const handleChange = (e: any, meta: ActionMeta<unknown>) => {
    let result = {key: slot, value: ''};    
    if (meta.action === 'select-option') {
      const value = e!.value !== '_' ? e!.value : '';
      result = {key: slot, value};
    }
    dispatch(setWornItem(result));  
    dispatch(getTrainerResults());
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (isMenuOpen.current) {
      return;
    }

    const instance = myRef.current;
    if (e.code === 'ArrowUp') {
      e.preventDefault();
      const value = instance.getValue();
      if (value.length) {
        const index = options.findIndex((x: any) => x === instance.getValue()[0]);
        if (index > 0) {
          const option = options[index - 1];
          const result = { key: slot, value: option.value !== '_' ? option.value : '' };
          dispatch(setWornItem(result));
          dispatch(getTrainerResults());
        }
      }
    }
    else if (e.code === 'ArrowDown') {
      e.preventDefault();
      const value = instance.getValue();
      if (!value.length) {
        const value = options[1];
        const result = { key: slot, value: value.value };
        dispatch(setWornItem(result));
        dispatch(getTrainerResults());
      } else {
        const index = options.findIndex((x: any) => x === instance.getValue()[0]);
        if (index < options.length - 1) {
          const option = options[index + 1];
          const result = { key: slot, value: option.value !== '_' ? option.value : '' };
          dispatch(setWornItem(result));
          dispatch(getTrainerResults());
        }
      }
    }
  }

  return (
    <Select
      {...rest}
      ref={myRef}
      value={value}
      options={options}
      isClearable={true}
      menuPlacement="auto"
      onChange={(e,o)=>{handleChange(e, o)} }
      onMenuOpen={() => (isMenuOpen.current = true)}
      onMenuClose={() => (isMenuOpen.current = false)}
      onKeyDown={(e) => handleKeyDown(e)}
      unstyled
      className="eqtrainer-autocomplete"
      classNamePrefix="autocomplete"
    />
  );
}